// Source: https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side#52414433
export default function saveFile(utf8Content: string, fileNameWithExtension: string): void{
  const downloadLink = window.document.createElement('a');
  // UTF-8 BOM supported
  downloadLink.setAttribute('href', `data:text/csv;charset=utf-8,%EF%BB%BF${  encodeURI(utf8Content)}`);
  downloadLink.setAttribute('download', fileNameWithExtension);
  downloadLink.click();
}
